module.exports = __webpack_public_path__ + "img/MENU_DETALHADO.e371a503.png";